import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
export function HeroSection() {
  return <section className="w-full bg-cream pt-16 pb-20 px-6 md:pt-24 md:pb-28 overflow-hidden" data-id="element-89">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-90">
        <FadeIn data-id="element-91">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-slate-900 leading-tight mb-4" data-id="element-92">
            Detén el Ataque de Pánico de tu Hijo en 5 Minutos
            <span className="block text-2xl md:text-3xl text-sage-dark mt-2 font-sans font-medium" data-id="element-93">
              (Sin Medicamentos ni Teorías Aburridas)
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-94">
          <h2 className="text-lg md:text-xl text-slate-700 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-95">
            <span className="font-bold text-slate-900" data-id="element-96">
              La Guía de Rescate "Ansiedad Exprés":
            </span>{' '}
            El protocolo exacto para pasar de la taquicardia a la calma total
            cuando el miedo ataca de la nada.
          </h2>
        </FadeIn>

        <FadeIn delay={0.4} className="w-full max-w-3xl mb-12 relative" data-id="element-97">
          <div className="absolute inset-0 bg-sage-light rounded-3xl transform -rotate-2 scale-105 -z-10" data-id="element-98"></div>
          <img src="https://cdn.magicpatterns.com/uploads/3GUnHVhEKzuus1wqinPecT/ansiedadexpress.png" alt="Ansiedad Exprés - Guía de Rescate en Laptop y Tablet" className="w-full h-auto rounded-xl shadow-2xl" data-id="element-99" />
        </FadeIn>

        <FadeIn delay={0.6} className="flex flex-col items-center w-full max-w-md" data-id="element-100">
          <motion.a href="#oferta" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} animate={{
          boxShadow: ['0px 0px 0px rgba(232, 145, 58, 0)', '0px 0px 20px rgba(232, 145, 58, 0.5)', '0px 0px 0px rgba(232, 145, 58, 0)']
        }} transition={{
          repeat: Infinity,
          duration: 2
        }} className="w-full bg-amber hover:bg-amber-dark text-white font-bold text-lg md:text-xl py-5 px-8 rounded-xl shadow-lg transition-colors text-center" data-id="element-101">
            Descargar Guía de Rescate Ahora ($17)
          </motion.a>
          <p className="text-sm text-slate-600 mt-4 flex items-center justify-center gap-2" data-id="element-102">
            <svg className="w-4 h-4 text-sage-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-103">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-104"></path>
            </svg>
            Recibe el acceso directamente en tu correo en menos de 60 segundos.
          </p>
        </FadeIn>
      </div>
    </section>;
}